import React from 'react';
import { AlertCircle, EyeOff, Ghost, GlobeLock } from 'lucide-react';

const ProblemSection: React.FC = () => {
  const pitfalls = [
    {
      icon: <AlertCircle className="w-6 h-6 text-[#D4AF37] mb-6" />,
      title: "Presentation Trust",
      desc: "Investors don’t trust your presentation because it lacks the technical rigor they expect."
    },
    {
      icon: <EyeOff className="w-6 h-6 text-[#D4AF37] mb-6" />,
      title: "Buyer Verification",
      desc: "Buyers can’t verify your credibility, leading them to seek suppliers with more transparent track records."
    },
    {
      icon: <Ghost className="w-6 h-6 text-[#D4AF37] mb-6" />,
      title: "Informal Perception",
      desc: "Your business looks informal, even when it isn't, causing it to be systematically undervalued."
    },
    {
      icon: <GlobeLock className="w-6 h-6 text-[#D4AF37] mb-6" />,
      title: "Digital Invisibility",
      desc: "You are invisible to global procurement teams online, missing out on direct-to-buyer opportunities."
    }
  ];

  return (
    <section id="advisory" className="py-32 max-w-[1440px] mx-auto px-8 scroll-mt-32">
      <div className="flex flex-col gap-16">
        {/* Narrative Header - Level 1 Label */}
        <div className="max-w-4xl">
          <span className="text-[#D4AF37] text-[11px] font-black uppercase tracking-[0.3em] mb-6 block">The Critical Gap</span>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tighter leading-tight text-zinc-950 mb-8">
            Most African Mines Don’t Fail Geologically. They Fail Perceptually.
          </h2>
          <div className="text-lg text-zinc-600 leading-relaxed max-w-3xl">
            <p>
              Your operation may be viable, your resource may be proven, and your production may be stable—but without institutional-grade positioning, your value remains trapped behind a wall of skepticism and informal optics.
            </p>
          </div>
        </div>

        {/* Grid of Issues - Glass Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {pitfalls.map((item, idx) => (
            <div 
              key={idx} 
              className="p-10 bg-white/40 backdrop-blur-sm hover:bg-white/80 transition-all rounded-sm border border-white/40 shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-xl group"
            >
              <div className="p-3 bg-white rounded-sm inline-block mb-2 transition-all shadow-none">
                {item.icon}
              </div>
              <h4 className="font-bold text-[14px] uppercase tracking-widest mb-3 text-zinc-950">{item.title}</h4>
              <p className="text-sm text-zinc-500 leading-relaxed max-w-md">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;